import { render } from "./AthleteCard.vue?vue&type=template&id=3e499394&scoped=true"
import script from "./AthleteCard.vue?vue&type=script&lang=js"
export * from "./AthleteCard.vue?vue&type=script&lang=js"

import "./AthleteCard.vue?vue&type=style&index=0&id=3e499394&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e499394"]])

export default __exports__